import axios from "axios";

export async function getAvailableSlotsByDate(year, month, day) {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getAvailableSlots/${year}/${month}/${day}`
    );
    const data = await res.json();
    return data;
  } catch (err) {
    throw err;
  }
}

export const searchExistingBooking = async (phoneNumber, emailAddress) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getTokenByContactDetails`,
      {
        phoneNumber,
        emailAddress,
      }
    );
    return response.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const monthlyDataCache = new Map();
export const getMonthlyData = async (year, month) => {
  const key = `${year}-${month}`;
  if (monthlyDataCache.has(key)) return monthlyDataCache.get(key);
  const promise = axios
    .get(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getMonthlyData/${year}/${month}`
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    })
    .finally(() => {
      monthlyDataCache.delete(key);
    });

  monthlyDataCache.set(key, promise);
  return promise;
};

export const addBooking = async (body) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/addBooking`,
      body
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getDailyData = async (day, month, year) => {
  try {
    const dailyData = await axios.get(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getDailyData/${year}/${month}/${day}`
    );
    return dailyData.data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const updateBookingDate = async (bookingId, body) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/updateBooking/${bookingId}`,
      body
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const deleteBooking = async (bookingId, token) => {
  try {
    await axios.delete(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/deleteBooking/${bookingId}/${token}`
    );
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const searchForBooking = async (token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BOOKING_API_URL}/booking/getBookingByToken/${token}`
    );
    return response;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
